<style lang="less" scoped>
  .td_left {width: 150px;text-align-last: left;text-indent: 10px;background-color: #fcfcfc;}
  .after {text-align: left;background-color: #fcfcfc;}
  .after .el-button {height: 40px;}
  .f_red {color: red;margin-right: 5px;}
  .f_hid {color: #ffffff;margin-right: 5px;}
  tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
  .tr .td {float: left;}
  .tr {width: 100%;height: 50px;}
  .td {margin-left: 10px;}
  table {border-collapse: collapse;width: 100%;}
  .el-checkbox__inner {border-radius: 50%;}
  .first .introduce {width: 100%;}
  .first /deep/ .el-input {width: 400px;}
  .level /deep/ .el-input {width: 200px;}
  .ssgj_tr /deep/ .el-input {width: 400px;}
  .edui-default /deep/ .edui-editor-iframeholder {height: 40%;}
  .el-form-item {margin-bottom: 0;float: left;}
  .jianjie_tr .el-form-item {width: 100%;}
  .catid_tr .el-form-item:nth-of-type(2) {margin-left: 10px;}
  .tr2 .el-form-item:nth-of-type(2) {margin-left: 10px;}
  /deep/.el-upload-list--picture-card .el-upload-list__item-thumbnail {position: absolute;margin: auto;top: -9999px;right: -9999px;bottom: -9999px;left: -9999px;height: auto}
  .formBox {padding-bottom: 70px;}
  .btnfixed {margin: 0px auto;height: 60px;z-index: 19999;}
  .btnfixed .el-button {height: 40px;margin: 10px auto;}
  .btnfixed {position: fixed;bottom: 0;left: 0;right: 0;height: 60px;background: #f8f4f4;margin-left: 240px;background-color: #dff0d8;}
  /deep/.el-form-item__error {font-size: 16px;height: 40px;line-height: 40px;float: right;margin-left: 10px;position:static;padding-top: 0;}
  /deep/.el-icon-close-tip {display: none;}
  /deep/.el-dialog__wrapper {z-index: 20000 !important;}
</style>
<template>
  <div class="first" id="first">
    <el-form ref="form" :model="form" class="formBox">
      <table>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>类型
          </td>
          <td class="after">
            <el-form-item>
              <el-select clearable v-model="form.type" class="select classification">
                <el-option v-for="item in options_genderType" :key="item.value" :label="item.label" :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </td>
        </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>会议名称
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.name"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr class="tr">
            <td class="td_left">
            <span class="f_hid">*</span>会议类型
            </td>
            <td class="after">
              <el-checkbox-group v-model="form.difference">
                <el-checkbox label="线上会议"></el-checkbox>
                <el-checkbox label="线下会议"></el-checkbox>
              </el-checkbox-group>
            </td>
          </tr>
        <tr class="author_tr">
          <td class="td_left">
            <span class="f_hid">*</span>会议时间
          </td>
          <td class="after">
            <el-form-item>
              <el-input v-model="form.begintime"></el-input>
            </el-form-item>
          </td>
        </tr>
      </table>
    </el-form>
    <div class="btnfixed">
      <el-button type="success" @click="addfn()" v-if="this.$route.path === '/Kyzhgl'">添加</el-button>
      <el-button type="success" @click="modification" v-else-if="this.$route.path === '/KyltMUpdate'">确定</el-button>
      <el-button @click="cancelfn()" v-if="this.$route.path === '/Kyzhgl'">取消</el-button>
      <el-button @click="backtrack" v-else-if="this.$route.path === '/KyltMUpdate'">返回</el-button>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: ['updataID'],
  data()
  {
    return {
      form: {
        type: '',
        name: '',
        difference: [],
        begintime: ''
      },
      options_genderType: [
        {
          value: 0,
          label: '会议'
        },
        {
          value: 1,
          label: '展会'
        }
      ],
      datalength: null
    }
  },
  async created()
  {
    this.isgetData()
    this.getCount()
  },
  methods: {
    getCount()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 105,
        _exp: 'id > ?',
        types: 'i',
        vals: 0
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.datalength = ret.length + 1
      })
    },
    //添加
    addfn()
    {
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 105,
        retAtt: 1,
        type: this.form.type,
        name: this.form.name,
        begintime: this.form.begintime,
        author: userInfo.userno,
        orders: this.datalength,
        difference: this.form.difference.toString()
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '添加成功', type: 'success', customClass: 'mzindex'})
          this.$emit('removeTab')
          this.$store.commit('onKyltMid', '1')
        }
      })
    },
    // 获取需要修改的数据
    isgetData()
    {
      if (this.$route.path === '/KyltMUpdate')
        this.getData()
    },
    getData()
    {
      let paras = {
        cmd: 'query',
        _major: 11,
        _minor: 105,
        _exp: 'id=?',
        types: 'i',
        vals: this.updataID
      }
      window.post.getPost(paras).then((ret) =>
      {
        this.form.id = ret[0].id
        this.form.type = ret[0].type
        this.form.name = ret[0].name
        this.form.begintime = ret[0].begintime
        this.form.difference = ret[0].difference.split(',')
      })
    },
    //修改
    modification()
    {
      let userInfo = JSON.parse(localStorage.getItem('userMsg'))
      let obj = {
        cmd: 'updateAtt',
        _major: 11,
        _minor: 105,
        retAtt: 1,
        id: this.form.id,
        type: this.form.type,
        name: this.form.name,
        begintime: this.form.begintime,
        author: userInfo.userno,
        difference: this.form.difference.toString()
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '修改失败', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$message({message: '修改成功', type: 'success', customClass: 'mzindex'})
          this.$router.push({path: '/Kyzhgl'})
          this.$store.commit('onActiveName', '1')
        }
      })
    },
    //返回
    backtrack()
    {
      this.$router.go(-1)
    },
    //取消(移除Tabs页)
    cancelfn()
    {
      this.$emit('removeTab')
    }
  }
}
</script>



// WEBPACK FOOTER //
// static/form/KyltMAdd.vue